module.exports = __webpack_public_path__ + "img/icono_conductor.b5d93fe7.svg";